// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/styles/app.scss
// module id = 2
// module chunks = 0